<script setup lang="ts">
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { shareOutline, shareSocialOutline } from 'ionicons/icons';
import { IonButton, IonIcon, isPlatform } from '@ionic/vue';
import { useI18n } from 'vue-i18n';

import useTenant from '@/shared/composables/useTenant';
import useUtils from '@/shared/composables/useUtils';

// Init
const { t } = useI18n();
const { getTenantConfigAndStyles } = useTenant();
const { tenantStyles } = getTenantConfigAndStyles();
const { getCurrentWindowLocationOrigin } = useUtils();

const shareApp = () => {
	if (Capacitor.isNativePlatform()) {
		// Share on native platforms
		Share.share({
			title: tenantStyles.value!.name,
			text: t('components.share_app.message'),
			url: `${getCurrentWindowLocationOrigin()}/#/share`,
		});
	} else {
		// Share on web platforms
		navigator.share({
			title: tenantStyles.value!.name,
			text: t('components.share_app.message'),
			url: `${getCurrentWindowLocationOrigin()}/#/share`,
		});
	}
};
</script>

<template>
	<div class="flex flex-col items-center justify-center mb-2 py-4 rounded-md">
		<div class="flex items-center justify-evenly w-full">
			<ion-button fill="outline" shape="round" @click="shareApp">
				<ion-icon :icon="isPlatform('android') || !Capacitor.isNativePlatform() ? shareSocialOutline : shareOutline" class="text-white mr-2"> </ion-icon>
				<span class="text-white text-base2 font-sourcesanspro-regular">
					{{ t('components.share_app.share') }}
				</span>
			</ion-button>
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
